"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _invariant = _interopRequireDefault(require("invariant"));
var _Context = require("./Context");
var _configureStore = _interopRequireDefault(require("../store/configureStore"));
var _translations = require("../constants/translations");
var _GlobalStyles = require("../../components/GlobalStyles");
var _Breadcrumbs = require("./Breadcrumbs");
var _Layout = _interopRequireDefault(require("./Layout"));
var _i18n = _interopRequireDefault(require("../services/i18n"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AppFrame = (0, _react.memo)(({
  children = null,
  theme = {},
  localeData,
  i18n,
  includeFonts = false,
  ...other
}) => {
  (0, _invariant.default)(!(i18n && !localeData), "Please, provide 'localeData' in case of passing 'i18n'");
  const i18Instance = i18n || _i18n.default;
  const locale = localeData || i18Instance.getResource && i18Instance.getResource(other.config.locale, 'translation', 'AppFrame') || _translations.defaultTranslations;
  const store = _configureStore.default.initStore(other.config, locale);
  return _react.default.createElement(_Breadcrumbs.BreadcrumbsProvider, null, _react.default.createElement(_reactI18next.I18nextProvider, {
    i18n: i18Instance
  }, _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, _react.default.createElement(_GlobalStyles.GlobalStyles, {
    includeFonts: includeFonts
  }), _react.default.createElement(_reactRedux.Provider, {
    store: store,
    context: _Context.AppFrameContext
  }, _react.default.createElement(_Context.ConfigContext.Provider, {
    value: other.config
  }, _react.default.createElement(_Context.LocaleContext.Provider, {
    value: locale
  }, _react.default.createElement(_Layout.default, (0, _extends2.default)({}, other, {
    localeData: locale
  }), children)))))));
});
var _default = exports.default = AppFrame;